import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

export const Rows = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const TileCard = styled.div`
    border-radius: ${radii.base};
    background: ${colors.surface};
    box-shadow: ${shadows.panel};
    overflow: hidden;
`;

export const TileBody = styled.div`
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
